module.exports = __webpack_public_path__ + "assets/img/a877-gb-eng.svg";